import { useQuery } from '@tanstack/react-query';
import { fetchCapabilities, type Capabilities } from '@/services/serviceProfiles';

const DEFAULT: Capabilities = {
  figmaPush: false,
  designTokenExtraction: false,
  unblockedEnrichment: false,
  stitchRedesign: false,
  geminiVision: false,
  linearIntegration: false,
};

export function useCapabilities(): Capabilities {
  const { data } = useQuery({
    queryKey: ['capabilities'],
    queryFn: fetchCapabilities,
    staleTime: 60_000,
  });
  return data ?? DEFAULT;
}
